import { FC, CSSProperties } from 'react';
import styles from './index.module.less';
import { useTranslation } from '@/hooks/useTranslation';
import { redirectToPDP, getPDPUrlWithoutSearch } from '@/components/ProductCard/utils';
import { SearchTracker } from '@/utils/Tracker';
import { searchReport } from '@/pages/search/report';
import { TScene } from '../SearchBar/typings';
import { Trans } from '@/lib/react-trans';
import cls from 'classnames';

/** 搜索相关的建议结果 */
export interface ISuggestionItem {
  opsRequestMisc: string;
  commodity: {
    commodityId: number;
    commodityName: string;
  };
  // 组件id
  id: number;
  product: {
    productId: number;
    productName: string;
    urlKey: string;
  };
  requestId: string;
}

interface ISuggestionItemProps {
  data: ISuggestionItem;
  scene: `${TScene}-recommend`;
}

interface Props {
  data: ISuggestionItem[];
  scene: `${TScene}-recommend`;
  wrapperStyle?: CSSProperties;
}

const Suggestions: FC<Props> = ({ data, scene }) => {
  const { trans } = useTranslation();
  if (!data.length) return null;
  return (
    <div
      className={cls({
        [styles.wrapper]: true,
        [styles.searchResults]: scene === 'search-result-recommend',
      })}
    >
      <span className={styles.title}>{trans('common.search.suggestedLinks')}</span>
      <div className={styles.options}>
        {data.map((suggestion) => {
          return <SuggestionItem data={suggestion} key={suggestion.id} scene={scene} />;
        })}
      </div>
    </div>
  );
};

const SuggestionItem: FC<ISuggestionItemProps> = ({ data, scene }) => {
  return (
    <div className={styles.item}>
      <div
        className={styles.link}
        onClick={() => {
          // 搜索埋点 - 推荐点击
          SearchTracker.searchBarTracing({
            action: 'quick_link_click',
            labels: {
              sku: `${data.commodity.commodityId}`,
              skuPath: getPDPUrlWithoutSearch(data),
            },
          });
          // OpenSearch数据上报
          searchReport({
            bhvType: 'click',
            bhvValue: 1,
            itemIdList: [data.id],
            rn: data.requestId,
            traceInfo: '',
          });
          // 跳转页面
          redirectToPDP(data, scene, {
            pid: `${data.product.productId}`,
            cid: `${data.commodity.commodityId}`,
            itemIdList: [data.id],
            rn: data.requestId,
            traceInfo: data.opsRequestMisc,
          });
        }}
      >
        <Trans
          text={data.product.productName}
          components={{
            strong: <span className={styles.highLight}></span>,
          }}
        ></Trans>
      </div>
    </div>
  );
};

export default Suggestions;
